import { useServiceCenterState } from '@apps/serviceCenter/ServiceCenterState';

export const useServiceCenterController = () => {
  const { isLoading, isSuperAdmin, currentUserName } = useServiceCenterState();

  return { isLoading, isSuperAdmin, currentUserName };
};
